export const PaySection = {
    path: '/pay_sections',
    name: 'pay_sections',
    component: () => import('@/views/PaySection/PaySectionPage.vue'),
    children: [
         {
            path: '/pay_sections/easy_create/:type',
            name: 'pay_sections.easy_create',
            component: () => import('@/views/PaySection/Form/PaySectionEasyCreateForm.vue'),
        },
        {
            path: '/pay_sections/add',
            name: 'pay_sections.add',
            component: () => import('@/views/PaySection/Form/PaySectionForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/pay_sections/edit/:id',
            name: 'pay_sections.edit',
            component: () => import('@/views/PaySection/Form/PaySectionForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/pay_sections/delete/:id',
            name: 'pay_sections.delete',
            component: () => import('@/views/PaySection/Form/PaySectionForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/pay_sections/view/:id',
            name: 'pay_sections.view',
            component: () => import('@/views/PaySection/Form/PaySectionForm.vue'),
            props: {viewAction: true}
        },
    ],
}